import React from 'react';

import { useGetCard } from '@vlabs/api/point-api/client';

import { ListItem } from '@vlabs/monokit/entities/data-items';
import { AttachCardsToListIconButton } from '@vlabs/monokit/features/attach-cards-to-list';
import { DetachCardsFromListIconButton } from '@vlabs/monokit/features/detach-cards-from-list';
import { useCardIdFromLocation } from '@vlabs/monokit/shared/lib/use-card-id-from-location';
import { buildTestid } from '@vlabs/monokit/shared/lib/utils';

import { usePersonListsTranslation } from './i18n';
import st from './PersonLists.module.sass';

const displayName = 'PersonLists';
const testid = buildTestid(displayName);

export function PersonLists(): React.JSX.Element {
  const { t } = usePersonListsTranslation();

  const cardId = useCardIdFromLocation();
  const getCard = useGetCard(cardId);

  const cardLists = getCard.data?.lists ?? [];
  const hasLists = cardLists.length > 0;

  return (
    <div
      className={st.Container}
      {...testid()}
    >
      <div className={st.Header}>
        <h6>{t('title')}</h6>

        <AttachCardsToListIconButton cardIds={[cardId]} />
      </div>

      {!!hasLists && (
        <div className={st.List}>
          {cardLists.map((listId) => (
            <ListItem
              actions={(
                <DetachCardsFromListIconButton
                  cardId={cardId}
                  fromListId={listId}
                />
              )}
              key={listId}
              listId={listId}
            />
          ))}
        </div>
      )}

      {!hasLists && (
        <div className={st.Empty}>
          {t('no_data')}
        </div>
      )}
    </div>
  );
}
